import type { SiteConfig } from '../../@types/context/site-config.types';
import { serviceTrustpilotAxoConfig } from './service-trustpilot-axo.config';

export const serviceTrustpilotAxoNoConfig: SiteConfig['services']['trustpilot'] =
  {
    ...serviceTrustpilotAxoConfig,
    businessUnitId: '5476fe0400006400057bcaf1',
  };
